/**
 * 采集详情页上下文管理
 * 职责：管理采集详情页相关的上下文数据
 */

import { contextManager } from "./ContextManager";

export interface PinDetailContextData {
  pin_id: string;
  board_id?: string;
  file_id?: string;
  content_type?: string;
  pin_source?: string;

  // 扩展字段
  ext?: Record<string, any>;
}

const PIN_DETAIL_CONTEXT_KEY = "pin_detail";
const PIN_DETAIL_CONTEXT_TTL = 10 * 60 * 1000; // 10分钟

export class PinDetailContext {
  /**
   * 创建详情页上下文
   */
  static create(data: PinDetailContextData): void {
    contextManager.register(PIN_DETAIL_CONTEXT_KEY, {
      type: "pin_detail",
      data,
      metadata: {
        createdAt: Date.now(),
        ttl: PIN_DETAIL_CONTEXT_TTL,
        scope: "page",
        sessionId: `pin_${Date.now()}_${Math.random().toString(36).slice(2)}`,
      },
    });

    if (process.env.NODE_ENV === "development") {
      console.log("[PinDetailContext] Created:", data);
    }
  }

  /**
   * 更新详情页上下文
   */
  static update(data: Partial<PinDetailContextData>): void {
    contextManager.merge(PIN_DETAIL_CONTEXT_KEY, data);

    if (process.env.NODE_ENV === "development") {
      console.log("[PinDetailContext] Updated:", data);
    }
  }

  /**
   * 获取详情页上下文
   */
  static get(): PinDetailContextData | null {
    const context = contextManager.get(PIN_DETAIL_CONTEXT_KEY);
    return context ? (context.data as PinDetailContextData) : null;
  }

  /**
   * 清除详情页上下文
   */
  static clear(): void {
    contextManager.clear(PIN_DETAIL_CONTEXT_KEY);

    if (process.env.NODE_ENV === "development") {
      console.log("[PinDetailContext] Cleared");
    }
  }

  /**
   * 订阅详情页上下文变化
   */
  static subscribe(
    listener: (data: PinDetailContextData | null) => void
  ): () => void {
    return contextManager.subscribe(PIN_DETAIL_CONTEXT_KEY, (context) => {
      listener(context?.data as PinDetailContextData | null);
    });
  }
}
